import script from "./ExamTestMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamTestMain.vue?vue&type=script&setup=true&lang=ts"

import "./ExamTestMain.vue?vue&type=style&index=0&id=36e272bb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e272bb"]])

export default __exports__